import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {UtilService} from '../../../shared/services/util.service';
import { MaterialModule } from 'src/app/app.materials';
import { FormsModule } from '@angular/forms';
import { LineChartComponent } from '../../line-chart/line-chart.component';

@Component({
  selector: 'app-drawdown',
  templateUrl: './drawdown.component.html',
  standalone: true,
  imports: [MaterialModule, FormsModule, LineChartComponent]
})
export class DrawdownComponent implements OnInit, OnChanges {

  @Input() index: any = {};
  @Input() benchmark: any = {};

  series: any[] = [];

  constructor(
    private util: UtilService
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.index) {
      this.index = changes.index.currentValue;
      this.initSeries();
    }
    if (changes.benchmark) {
      this.benchmark = changes.benchmark.currentValue;
      this.initSeries();
    }
  }

  initSeries() {
    this.series = [];
    const indexSeries = this.util.initSeries(this.index, 'drawdownComparison');
    if (indexSeries) {
      this.series.push(indexSeries);
    }
    const benchmarkSeries = this.util.initSeries(this.benchmark, 'drawdownComparison');
    if (benchmarkSeries) {
      this.series.push(benchmarkSeries);
    }
  }
}
